import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/models';
import { Visitation } from 'src/app/models/domain';
import { IVisitationResponse } from 'src/app/models/share-point';

@Injectable({
  providedIn: 'root',
})
export class VisitationAdapter implements IAdapter<Visitation, IVisitationResponse> {
  public adaptToDomain(fields: IVisitationResponse): Visitation {
    return new Visitation(
      fields.webUrl,
      fields.fileName,
      fields.id,
      fields.Order_x0020_Type,
      fields.Part_x0020_number,
      fields.C64_x0020_Date,
      fields.Material_x0020_1,
      fields.Material_x0020_2,
      fields.Planning_x0020_Status,
      fields.Dev_x0020_Segment,
      fields.Mould_x0020_definition,
      fields.Mould_x0020_type,
      fields.Cavities,
      fields.MM_x0020_Profile,
      fields.MQ_x0020_Profile,
      fields.Mould1_x0020_plant,
      fields.TED_x0020_Start,
      fields.TED_x0020_End_x0020__x0028_C45_x0029_,
      fields.PTY_x0020_Start,
      fields.PTY_x0020_End_x0020__x0028_C46_x0029_,
      fields.PTY_x0020_Eval_x0020_start,
      fields.PTY_x0020_Eval_x0020_End_x0020__x0028_C47_x0029_
    );
  }
}
